import axios from 'axios'

const initialNotificationsState = {
  toRead: 0,
  notifications: [],
  processingNotificationQueue: false,
  notificationDisplayCurrent: {},
  showNotificationDrawer: false,
  drawerNotifications: [],
  drawerNotificationsUnread: [],
  drawerNotificationsRead: [],
  totalNotificationCounter: 0,
  unreadNotificationCounter: 0,
  readNotificationCounter: 0
}

const notificationMutations = {
  enqueueNotification (state, { notification }) {
    state.notifications.push(notification)
  },
  dequeueNotification (state) {
    if (state.notifications.length <= 0) {
      return false
    }
    return state.notifications.shift()
  },
  setProcessNotificationQueue (state, { processQueue }) {
    state.processingNotificationQueue = processQueue
  },
  setCurrentNotification (state, { notification }) {
    state.notificationDisplayCurrent = notification
  },

  toggleNotificationDrawer (state) {
    state.showNotificationDrawer = !state.showNotificationDrawer
  },
  setDrawerNotifications (state, { payload }) {
    state.drawerNotifications = payload.notifications
    state.totalNotificationCounter = payload.totalNotificationCounter
  },
  setDrawerNotificationsUnread (state, { unreadNotifications }) {
    state.drawerNotificationsUnread = unreadNotifications
  },
  setDrawerNotificationsRead (state, { readNotifications }) {
    state.drawerNotificationsRead = readNotifications
  },
  clearDrawerNotifications (state) {
    state.drawerNotifications = []
  },
  clearDrawerNotificationsUnread (state) {
    state.drawerNotificationsUnread = []
  },
  clearDrawerNotificationsRead (state) {
    state.drawerNotificationsRead = []
  },
  setUnreadNotificationCounter (state, { unreadNotificationCounter }) {
    state.unreadNotificationCounter = unreadNotificationCounter
  },
  setReadNotificationCounter (state, { readNotificationCounter }) {
    state.readNotificationCounter = readNotificationCounter
  },
  removeUnreadNotification (state, { updatedNotification }) {
    const idx = state.drawerNotificationsUnread.findIndex(
      n => n.id === updatedNotification.id
    )
    if (idx !== -1) {
      state.drawerNotificationsUnread.splice(idx, 1)
    }
  },
  updateReadNotification (state, { updatedNotification }) {
    const idx = state.drawerNotifications.findIndex(
      n => n.id === updatedNotification.id
    )
    if (idx !== -1) {
      let updatedNotifications = Array.from(state.drawerNotifications)
      state.drawerNotifications = []

      updatedNotifications[idx] = updatedNotification
      state.drawerNotifications = updatedNotifications
    }
  }
}

const notificationActions = {
  showNextInQueue ({ commit, getters }) {
    if (getters.isProcessing) {
      const result = getters.topQueueNotification

      commit({
        type: 'dequeueNotification'
      })

      if (result) {
        commit({
          type: 'setCurrentNotification',
          notification: result
        })
      }

      if (getters.notificationAreEmpty) {
        commit({
          type: 'setProcessNotificationQueue',
          processQueue: false
        })
      }
    }
  },
  processQueue ({ commit, getters }) {
    if (getters.isProcessing) {
      return false
    }
    commit({
      type: 'setProcessNotificationQueue',
      processQueue: true
    })

    const result = getters.topQueueNotification

    if (result) {
      commit({
        type: 'dequeueNotification'
      })

      commit({
        type: 'setCurrentNotification',
        notification: result
      })
    }
  },
  addNotificationToQueue ({ commit }, { notification }) {
    commit({
      type: 'enqueueNotification',
      notification
    })
  },
  getPendingNotificationNumber ({ commit }) {
    axios.get(`${process.env.VUE_APP_API_URL}/users/me/notifications/pending`)
      .then((response) => {
        const { data } = response
        let pending = data.pending
        commit({
          type: 'setUnreadNotificationCounter',
          unreadNotificationCounter: pending
        })
      })
  },
  getNotificationsUnread ({ commit }) {
    axios.get(`${process.env.VUE_APP_API_URL}/users/me/notifications?filter[read_at]=null`)
      .then((response) => {
        const { data } = response.data
        let unreadNotifications = data.slice(0, 10)
        commit({
          type: 'setDrawerNotificationsUnread',
          unreadNotifications
        })
      })
      .catch(() => {
        commit('clearDrawerNotificationsUnread')
      })
  },
  getNotificationsRead ({ commit }) {
    axios.get(`${process.env.VUE_APP_API_URL}/users/me/notifications/read`)
      .then((response) => {
        const { data, total } = response.data
        let readNotifications = data.slice(0, 10)
        commit({
          type: 'setReadNotificationCounter',
          readNotificationCounter: total
        })
        commit({
          type: 'setDrawerNotificationsRead',
          readNotifications
        })
      })
      .catch(() => {
        commit('clearDrawerNotificationsRead')
      })
  },
  getNotifications ({ commit }) {
    axios.get(`${process.env.VUE_APP_API_URL}/users/me/notifications`)
      .then((response) => {
        const { data, total } = response.data
        let payload = {
          'notifications': data,
          'totalNotificationCounter': total
        }
        commit({
          type: 'setDrawerNotifications',
          payload
        })
      })
      .catch(() => {
        commit('clearDrawerNotifications')
      })
  },
  checkAsRead ({ dispatch }, { notificationId }) {
    return axios.post(`${process.env.VUE_APP_API_URL}/users/me/notifications/${notificationId}/read`)
      .then(({ data }) => {
        dispatch('getPendingNotificationNumber')
        dispatch('getNotifications')
        dispatch('getNotificationsUnread')
        dispatch('getNotificationsRead')
        const { action } = data.data
        return { 'url': action }
      })
  },
  markAllAsRead ({ commit, dispatch }) {
    return axios.post(`${process.env.VUE_APP_API_URL}/users/me/notifications/read-all`)
      .then(() => {
        dispatch('getPendingNotificationNumber')
        commit({ type: 'clearDrawerNotificationsUnread' })
        dispatch('getNotifications')
        dispatch('getNotificationsRead')
      })
  }
}

const notificationGetters = {
  topQueueNotification: (state) => {
    return state.notifications[0]
  },
  notificationAreEmpty: (state) => {
    return !(state.notifications.length > 0)
  },
  isProcessing: (state) => {
    return state.processingNotificationQueue
  }
}

export {
  notificationActions,
  notificationMutations,
  initialNotificationsState,
  notificationGetters
}
